var firebaseUserIdToken = null;
var firebaseUserLocalId = null;
var firebaseUserRefreshToken = null;
var chatRefreshLastTimestamp = 0;

var name = '';
var password = '';
var emailId = '';

var messageDate, messageMinutes;
var fgc;
var fixedOptions = {
  productQueries: 'I have a query regarding a product.',
  quickQuote: 'I would like to generate a quick quote.',
  faq: 'I have a general query.',
  askTheUnderwriter: 'I would like to post a message to an Underwriter.',
};

function initiateChatBot() {
  //fgc = new FirebaseAIGroupChat({firebaseAPIKey:"AIzaSyCRvujGOCoDkoPhj1crWfsolTGRbpjpf6c", dialogflowAccessToken:"5c92989dd26e4d1ea000f1530a6d6bd3"});
  fgc = new FirebaseAIGroupChat();
  //$('.messages-content').mCustomScrollbar();
  setTimeout(function () {
    fgc.triggerDFEvent('WELCOME', showLoading, parseResponse, logError);
  }, 100);

  $('.message-submit').click(function () {
    insertMessage();
  });

  $('#plus').click(function () {
    $('.chat').animate({ height: '80vh' }, 500);
    $(this).hide(1000);
    $('.chatgroups-content').hide();
    $('#minus').show(1000);
  });

  $('#minus').click(function () {
    $('.chat').animate({ height: '45px' }, 500);
    $(this).hide(1000);
    $('.chatgroups-content').hide();
    // if (application_view_mode == "mobile"){
    // 	$(".chat").hide('fast',
    // 		function(){
    // 				$("#chatButtonMobile").show('fast');
    // 			}
    // 		);
    // }
    // else{
    // 	$('#plus').show(1000);
    // }
    $('#plus').show(1000);
  });

  $('.message-input').on('keydown', function (e) {
    if (e.which == 13) {
      insertMessage();
      return false;
    }
  });

  $('.message-input').bind('change keyup input paste', function (e) {
    if ($(this).val().substr(-1, 1) == '@') {
      $('.chatgroups-tags').slideDown();
    } else {
      $('.chatgroups-tags').slideUp();
    }
  });

  $('.chatgroups-tag-option').click(function () {
    $('.message-input').val($('.message-input').val().substring(0, -1) + $(this).text().trim());
    $('.chatgroups-tags').slideUp();
    $('.message-input').focus();
  });

  $('.chat-title div .avatar').click(function () {
    $('.chatgroups-content').slideToggle();
  });

  $('.chatgroups-option').click(function () {
    $(this).addClass('selected');
    switchChat();
  });

  $('#menu-button').click(function () {
    $('#chat-options').fadeToggle();
  });

  $('.fixedOptions').click(function () {
    insertMessage(fixedOptions[$(this).attr('data-attr')]);
    $('#chat-options').fadeToggle();
  });
  // if (application_view_mode == "mobile"){
  // 	$(".chat").hide();
  // }
  // else {
  // 	$("#chatButtonMobile").hide();
  // }
  $('#chatButtonMobile').hide();

  $('#chatButtonMobile').click(function () {
    $('#chatButtonMobile').hide('fast');
    $('.chat').show('fast');
    $('#plus').click();
  });
}

function showLoading() {
  $('.messages-content').append(
    '<div class="message loading new"><figure class="avatar"><img src="' +
      $('.chat-title div .avatar img').attr('src') +
      '"/></figure><span></span></div>'
  );
  updateScrollbar();
}

function parseResponse(data) {
  // console.log("responce data:" + data.queryResult.fulfillmentText);
  // var receivedMessage = data.result.fulfillment.speech;
  // console.log('data');
  // console.dir(data);
  var receivedMessage = data.queryResult.fulfillmentText;
  $('.message.loading').remove();
  $('.messages-content').append(
    '<div class="message new"><figure class="avatar"><img src="' +
      $('.chat-title div .avatar img').attr('src') +
      '"/></figure>' +
      receivedMessage +
      '</div>'
  );
  setDate();
  updateScrollbar();
}

function logError(data) {
  //console.log(data);
  $('.message.loading').remove();
  $('.messages-content').append(
    '<div class="message new"><figure class="avatar"><img src="' +
      $('.chat-title div .avatar img').attr('src') +
      '"/></figure>Network Error!</div>'
  );
  setDate();
  updateScrollbar();
}

function switchChat() {
  $('.chatgroups-content').slideUp();
  var sourceDiv = $('.chatgroups-option.selected');
  var headerDiv = $('.chat-title div');
  sourceHtml = sourceDiv.html();
  sourceId = sourceDiv.attr('id');
  targetHTML = headerDiv.html();
  targetId = headerDiv.attr('id');

  headerDiv.html(sourceHtml);
  headerDiv.attr('id', sourceId);
  sourceDiv.html(targetHTML);
  sourceDiv.attr('id', targetId);
  sourceDiv.removeClass('selected');

  $('.chat-title div .avatar').click(function () {
    $('.chatgroups-content').slideToggle();
  });

  // $('.chat-title div .avatar img').attr('src') = $('.chat-title div .avatar img').attr('src');
  //$('.messages-content').mCustomScrollbar('destroy');
  $('.messages-content').html('');
  //$('.messages-content').mCustomScrollbar();
  setTimeout(function () {
    fgc.triggerDFEvent('WELCOME', showLoading, parseResponse, logError);
  }, 100);
}

function updateScrollbar() {
  if ($('.messages-content') != undefined)
    $('.messages-content').scrollTop($('.messages-content')[0].scrollHeight);
  // $('.messages-content').mCustomScrollbar('update').mCustomScrollbar('scrollTo', 'bottom', {
  //   scrollInertia: 10,
  //   timeout: 0,
  // });
}

function setDate() {
  messageDate = new Date();
  if (messageMinutes != messageDate.getMinutes()) {
    messageMinutes = messageDate.getMinutes();
    $('.message:last').append(
      '<div class="timestamp">' + messageDate.getHours() + ':' + messageMinutes + '</div>'
    );
  }
}

function insertMessage(msg) {
  if (msg == undefined) {
    msg = $('.message-input').val();
    if ($.trim(msg) == '') {
      return false;
    }
  }
  msg = msg.trim().replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  $('.messages-content').append('<div class="message message-personal new">' + msg + '</div>');
  setDate();
  $('.message-input').val(null);
  updateScrollbar();
  setTimeout(function () {
    fgc.getDFResponse(msg, showLoading, parseResponse, logError);
  }, 500);
}
